const names = {}

export function cacheTenantName(tenantId, tenantName) {
    if (tenantId && tenantName) {
        names[tenantId] = tenantName
    }
}

export function getCachedTenantName(tenantId) {
    return names[tenantId] || null
}

export function cacheTenantNames(tenants) {
    tenants.forEach(t => cacheTenantName(t.tenant_id, t.tenant_name))
}
